// extracted by mini-css-extract-plugin
export default {"socialContainer":"styles_socialContainer__0oGWe","socialLink":"styles_socialLink__cpnU1"};